import { Api } from "./api"

// const PATH = 'admin'
const ENDPOINTS = {
    Login:'login',
    Logout:'logout'
}

const login = (payload, signal) => {
    return Api.post(`${ENDPOINTS.Login}`,payload, signal)
}

const logout = (signal) => {
    return Api.post(`${ENDPOINTS.Logout}`,signal)
    // return Api.post()
}

export const authApi = {
    login,
    logout
}